/* Small global accessibility helpers.
   1. Links that open a new tab announce it. Theme sections already add the
      visually-hidden text in Liquid; this covers merchant-authored rich text
      (pages, articles, product descriptions) where the theme cannot. The
      wording comes from the locale file via data-new-window-text on <main>. */
(function () {
  'use strict';
  var main = document.getElementById('MainContent');
  var text = main && main.dataset.newWindowText;
  if (!text) return;

  function announce(root) {
    root.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      if (link.dataset.paNewWindow) return;
      link.dataset.paNewWindow = 'true';
      var name = (link.getAttribute('aria-label') || link.textContent || '').toLowerCase();
      if (name.indexOf(text.toLowerCase().replace(/\.$/, '')) !== -1) return;
      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      link.setAttribute('rel', rel.join(' '));
      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = ' ' + text;
      link.appendChild(span);
    });
  }

  announce(main);
  document.addEventListener('shopify:section:load', function (e) {
    announce(e.target || main);
  });
})();

/* 2. Off-screen third-party links (hCaptcha notice) out of the tab order while hidden. */
(function () {
  'use strict';
  var SELECTOR = 'a[href*="hcaptcha.com/"]';
  function isHidden(el) {
    var r = el.getBoundingClientRect();
    var docW = document.documentElement.scrollWidth;
    var docH = document.documentElement.scrollHeight;
    var offPage = r.right + window.scrollX <= 0 || r.bottom + window.scrollY <= 0 || r.left + window.scrollX >= docW || r.top + window.scrollY >= docH;
    if (offPage || r.width === 0 || r.height === 0) return true;
    for (var p = el; p && p !== document.body; p = p.parentElement) {
      var cs = getComputedStyle(p);
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return true;
    }
    return false;
  }
  function tame() {
    document.querySelectorAll(SELECTOR).forEach(function (a) {
      if (isHidden(a)) { if (!a.hasAttribute('data-pa-tabindex')) { a.setAttribute('data-pa-tabindex', a.getAttribute('tabindex') || ''); } a.setAttribute('tabindex', '-1'); }
      else if (a.hasAttribute('data-pa-tabindex')) { var t = a.getAttribute('data-pa-tabindex'); if (t) a.setAttribute('tabindex', t); else a.removeAttribute('tabindex'); a.removeAttribute('data-pa-tabindex'); }
    });
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; tame(); }); }
  if ('MutationObserver' in window) new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', schedule);
  tame();
})();

/* 3. Focus ring on embedded iframes (map). A cross-origin iframe never matches :focus
   in this document, so mark it while keyboard focus is inside it. */
(function () {
  'use strict';
  var keyboard = false;
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') keyboard = true; }, true);
  document.addEventListener('pointerdown', function () { keyboard = false; }, true);
  function clear() { document.querySelectorAll('iframe.pa-iframe-focus').forEach(function (f) { f.classList.remove('pa-iframe-focus'); }); }
  window.addEventListener('blur', function () {
    setTimeout(function () {
      var a = document.activeElement;
      if (keyboard && a && a.tagName === 'IFRAME') a.classList.add('pa-iframe-focus');
    }, 0);
  });
  window.addEventListener('focus', clear);
  document.addEventListener('focusin', clear);
})();
